<template>
  <div>
    <v-card
      tile
      elevation="0"
      color="transparent"
      class="d-flex align-center mb-3 px-2"
    >
      <div class="mr-2 text-h6">일정구분 관리</div>
      <v-btn fab small elevation="0" color="transparent" @click="onWrite">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-card>
    <setting-plan-list></setting-plan-list>
    <router-view @showResult="showResult"></router-view>
    <v-snackbar v-model="snackbar.show" timeout="1000">
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import SettingPlanList from "@/components/settings/SettingPlanList";

export default {
  data() {
    return {
      snackbar: {
        show: false,
        message: "",
      },
    };
  },
  components: { SettingPlanList },
  methods: {
    onWrite() {
      this.$router.push(`${this.$route.path}/write`);
    },
    showResult(ret, text) {
      if (ret > 0) {
        this.snackbar.message = `${text}되었습니다.`;
        this.snackbar.show = true;
      } else {
        this.snackbar.message = `${text} 실패.`;
        this.snackbar.show = true;
      }
    },
  },
};
</script>

<style></style>
